import { BackofficeARIDTO, DailySet, ValueTypes } from "../types";
import {
  ARIBucketConfig,
  StaticBundleData,
  BundleRateType,
} from "../../../../gen/witbooking/ari/v1/static_ari_pb";
import { InventoryLine } from "../../../../gen/witbooking/backoffice/inventory/v1/inventory_api_pb";
import { InventoryConfiguration } from "./InventoryConfiguration";

interface DailyValues {
  rate?: {
    dailySet?: DailySet[];
    parentTicker?: string;
  };
}

interface GetInventoryNameRequest {
  accommodation?: string;
  configuration?: string;
  mealPlan?: string;
  condition?: string;
  ticker: string;
}

const getDailyValue = (
  startDate: string,
  endDate: string,
  bucketConfig?: ARIBucketConfig.AsObject,
  ariElement?: {
    [key in ValueTypes]: {
      dailySet: DailySet[];
    };
  }
): DailyValues => {
  const result: DailyValues = {};
  if (bucketConfig?.rate && !bucketConfig.rate.parentTicker && !bucketConfig.rate.constant) {
    result.rate = {
      dailySet: ariElement?.rate?.dailySet || [{ startDate, endDate, value: 0 }],
      parentTicker: bucketConfig?.rate?.parentTicker,
    };
  }
  return result;
};

const getInventoryName = ({
  accommodation,
  configuration,
  mealPlan,
  condition,
  ticker,
}: GetInventoryNameRequest): string => {
  if (!accommodation || !configuration || !mealPlan || !condition) {
    return ticker;
  }
  return `${accommodation}, ${configuration}, ${mealPlan}, ${condition} (${ticker})`;
};

export class BundleInventoryData {
  ticker: string;
  dailyValues: DailyValues;
  name: string;
  configuration: InventoryConfiguration;

  private constructor(
    ticker: string,
    dailyValues: DailyValues,
    name: string,
    configuration: InventoryConfiguration
  ) {
    this.ticker = ticker;
    this.dailyValues = dailyValues;
    this.name = name;
    this.configuration = configuration;
  }

  static of(
    backofficeAriDto: BackofficeARIDTO,
    bundleInventoryList: StaticBundleData.AsObject[],
    inventoryLinesList: InventoryLine.AsObject[],
    startDate: string,
    endDate: string
  ): BundleInventoryData[] {
    // TODO: temporary, this should not be in a try/catch
    try {
      return bundleInventoryList
        .filter(bundle => bundle.bundleRateType === BundleRateType.BUNDLE_TYPE_OWN)
        .map(bundleInv => {
          const inventoryLine = inventoryLinesList.find(
            it => it.code === bundleInv.ticker.replace(`${bundleInv.bundleTicker}_`, "")
          ) as InventoryLine.AsObject;

          return new BundleInventoryData(
            bundleInv.ticker,
            getDailyValue(
              startDate,
              endDate,
              bundleInv.bucketConfig,
              backofficeAriDto[bundleInv.ticker]
            ),
            getInventoryName({
              accommodation: inventoryLine?.accommodation?.name,
              configuration: inventoryLine?.configuration?.name,
              mealPlan: inventoryLine?.mealPlan?.name,
              condition: inventoryLine?.condition?.name,
              ticker: bundleInv.ticker,
            }),
            {
              accommodation: inventoryLine?.accommodation?.ticker || "",
              condition: inventoryLine?.condition?.ticker || "",
              mealPlan: inventoryLine?.mealPlan?.ticker || "",
              occupancy: inventoryLine?.configuration?.ticker || "",
            }
          );
        });
    } catch (exception) {
      console.error("Error generating InventoryData", exception);
    }
    return [];
  }
}
